import { service } from '../index.js'

// 收货地址
export const address = {
  // 获取地址列表
  list: () => {
    return service.get('/address/list')
  },
  
  // 获取默认地址
  default: () => {
    return service.get('/address/default')
  },
  
  // 获取地址详情
  detail: (id) => {
    return service.get(`/address/detail/${id}`)
  },
  
  // 保存地址
  save: (data) => {
    return service.post('/address/save', data)
  },
  
  // 删除地址
  delete: (data) => {
    return service.post('/address/delete', data)
  },
  
  // 设置默认地址
  setDefault: (data) => {
    return service.post('/address/setDefault', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/address.js